<template>
  <el-row type="flex" align="middle" justify="start" style="padding: 12px; border-bottom: 1px solid lightgrey;">
    <el-col :span="!completed ? 16 : 12">
      <BankRecTabs :reconcilables="reconcilables" :activeTab="activeTab" @changeTabs="changeTabs"></BankRecTabs>
    </el-col>
    <el-col span="14">
      <el-row type="flex" justify="end" align="middle">
        <el-col class="h-padded left-aligned-col">
          <div style="display: block; margin-right: 10px; text-align: right; color: #6c757d; font-family: Helvetica, Arial, sans-serif; font-size: 12px;" v-if="activeTabRows" class="stats">
            {{(currentPage * pageLimit) - (pageLimit - 1) }} to {{activeTabRows < currentPage * pageLimit ? activeTabRows : currentPage * pageLimit}} of {{ activeTabRows }}
          </div>
        </el-col>
        <el-pagination
          ref="paginator"
          layout="prev, pager, next"
          :total="activeTabRows"
          :page-size="pageLimit"
          @current-change="changePage">
        </el-pagination>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
  import BankRecTabs from '@/components/Programs/BankRecon/BankRecTabs.vue'

  export default {
    components: {
      BankRecTabs
    },
    props: {
      completed: {
        'type': Boolean,
        'default': false,
        'required': false
      },
      reconcilables: {
        'type': Object,
        'required': true
      },
      pageLimit: {
        'type': Number,
        'default': 1000,
        'required': false
      },
      activeTabRows: {
        'type': Number,
        'required': true
      },
      currentPage: {
        'type': Number,
        'default': 1,
        'required': false
      },
      activeTab: {
        'type': String,
        'default': 'all',
        'required': false
      },
      changeTabs: {
        'type': Function,
        'required': false
      },
      changePage: {
        'type': Function,
        'required': false
      }
    },
    watch: {
      activeTab () {
        if (this.$refs.paginator) {
          this.$refs.paginator.handleCurrentChange(1)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Programs/BankRecon/BankRecTableHeader.vue